import SPACE from './space';

const GRID = {
  CONTAINER_MAX_WIDTH: 'xl',
  ROW_MARGIN: SPACE.X0,
  GUTTER_HALF: SPACE.X0,
} as const;

export default GRID;
